import React, { ReactElement, useState, useEffect } from "react";
import { Checkbox } from "antd";
import { patch } from "../../../libs/utils/request";
import "../NewRegistration.css";
import RegistrationButtons from "./RegistrationButtons";
import { ga } from "react-ga";

interface Props {
  roles?: any;
  skills: any;
  onClick?: (elem: any) => void;
  next: () => any;
  back: () => any;
  submit: (details: any) => any;
  step?: string;
}

const NewSkills = ({ skills, next, back, submit, step }: Props) => {
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [isDisabled, setDisabled] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [user, setUser] = useState(null);
  const [selectedSubtitle, setSelectedSubtitle] = useState("");

  useEffect(()=>{
    ga('send', { 'hitType': 'pageview', 'page': 'registration/skills', 'title': 'Registration skills' });
  },[])

  useEffect(() => {
    setUser(JSON.parse(sessionStorage.getItem("user")));
  }, [skills]);

  useEffect(() => {
    if (user && user.skills?.length > 0) {
      setSelectedDetails(user.skills);
    }
  }, [next]);

  useEffect(() => {
    if (selectedDetails.length > 4) {
      setDisabled(true);
    }
    if (selectedDetails.length < 5) {
      setDisabled(false);
    }
  }, [selectedDetails]);

  const addItems = (selected: any) => {
    if (
      !selectedDetails.find(function (item) {
        return item.id == selected.id;
      })
    ) {
      let item = selectedDetails;
      setSelectedDetails([...item, selected]);
    } else {
      deleteItems(selected.id);
    }
  };

  const deleteItems = (id: any) => {
    setSelectedDetails(selectedDetails.filter((element) => element.id !== id));
  };

  const onSubmit = async () => {
    const userDetails = {
      skills: selectedDetails,
    };
    submit(userDetails);
  };

  return (
    <div className="define-container">
      <div className="selected-items">
        {selectedDetails && (
          <div className="selected-item">
            {selectedDetails.map((selectedDetail: any) => (
              <div className="detail-item">
                <div>{selectedDetail.name}</div>
                <div
                  onClick={() => {
                    deleteItems(selectedDetail.id);
                  }}
                >
                  <img
                    className="close-icon"
                    src={"/images/close_black.svg"}
                    alt=""
                  />
                </div>
              </div>
            ))}
          </div>
        )}
            {<div>{5 - selectedDetails.length} more left</div>}
      </div>

      <div className="select-items-container">
        <div className="main-category">
          <div className="title-category">
            Skillsets
          </div>
          <hr className="registration_hr" />
          <div className="skill-select-holder">
            {skills.map((skill: any) => (
              <div
                key={skill.id}
                className={
                  selectedItemId === skill.id
                    ? "main-category-item-selected"
                    : "main-category-item"
                }
                onClick={() => {
                  setSelectedCategory(skill.skills),
                    setSelectedItemId(skill.id),
                    setSelectedSubtitle(skill.name);
                }}
              >
                {skill.name}
              </div>
            ))}
          </div>
        </div>
        <div className="details-category">
          <div className="title-details">{selectedSubtitle}</div>
          {selectedCategory && (
            <div className="details-select">
              {selectedCategory.map((selected: any) => (
                <Checkbox
                  disabled={isDisabled&&!selectedDetails.some(
                    (item) => item.id == selected.id
                  )}
                  checked={selectedDetails.some(
                    (item) => item.id == selected.id
                  )}
                  className="check-select"
                  onClick={() => addItems(selected)}
                >
                  {selected.name}
                </Checkbox>
              ))}
            </div>
          )}
        </div>
      </div>
      <RegistrationButtons
        roleName="Step3 (Skills)"
        showSkipButton
        showNextbutton
        showBackbutton
        next={next}
        back={back}
        save={() => {
          onSubmit();
        }}
      />
    </div>
  );
};

interface Props {
  title?: string;
  description?: string | ReactElement;
}

export default NewSkills;
